import React from 'react';
import './TestimonialsCaseStudy.css';

const TestimonialsCaseStudy: React.FC = () => {
  const caseStudy = {
    name: "Anna K.",
    role: "Uczennica klasy 3 liceum",
    beforeScore: "56%",
    afterScore: "91%",
    quote: "Dzieji kursom w Sigma Study zdalam mature rozszerzona z matematyki na 98%! Nauczyciele sa fantastyczni, wszystko tlumacza w sposob zrozumialy.",
    duration: "8 tygodni"
  };

  const testimonials = [
    {
      name: "Piotr N.",
      role: "Rodzic ucznia",
      text: "Moj syn mial ogromne problemy z matematyka. Po trzech miesiacach nauki jego oceny poprawily sie z 2 na 4+.",
      result: "z 2 na 4+"
    },
    {
      name: "Maria Z.",
      role: "Studentka",
      text: "Indywidualne lekcje z Kornelem to byla najlepsza inwestycja w moja edukacje. Analiza matematyczna stala sie moim ulubionym przedmiotem.",
      result: "Srednia 4.8"
    },
    {
      name: "Janek A.",
      role: "Uczen",
      text: "Kornel przygotowal mnie do Olimpiady Matematycznej Juniorow. Dzieki jego wsparciu zostalem laureatem 2 stopnia!",
      result: "Laureat OMJ"
    }
  ];

  return (
    <section id="testimonials" className="awesome-testimonials-section">
      <div className="awesome-testimonials-container">
        <div className="awesome-testimonials-header">
          <h2 className="awesome-testimonials-title">Historie sukcesu</h2>
          <p className="awesome-testimonials-subtitle">
            Poznaj wyniki naszych uczniow
          </p>
        </div>

        {/* Case Study Hero */}
        <div className="awesome-case-study">
          <div className="awesome-case-study-content">
            <span className="awesome-case-study-badge">Case Study</span>
            <h3 className="awesome-case-study-name">{caseStudy.name}</h3>
            <p className="awesome-case-study-role">{caseStudy.role}</p>

            <div className="awesome-case-study-metrics">
              <div className="awesome-metric">
                <span className="awesome-metric-label">Przed</span>
                <span className="awesome-metric-value before">{caseStudy.beforeScore}</span>
              </div>
              <div className="awesome-metric-arrow">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
              <div className="awesome-metric">
                <span className="awesome-metric-label">Po {caseStudy.duration}</span>
                <span className="awesome-metric-value after">{caseStudy.afterScore}</span>
              </div>
            </div>

            <blockquote className="awesome-case-study-quote">
              "{caseStudy.quote}"
            </blockquote>
          </div>
        </div>

        {/* Other Testimonials */}
        <div className="awesome-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="awesome-testimonial-card">
              <div className="awesome-testimonial-header">
                <div className="awesome-testimonial-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="awesome-testimonial-info">
                  <h4 className="awesome-testimonial-name">{testimonial.name}</h4>
                  <p className="awesome-testimonial-role">{testimonial.role}</p>
                </div>
              </div>

              <p className="awesome-testimonial-text">"{testimonial.text}"</p>

              <div className="awesome-testimonial-result">
                <span className="awesome-result-label">Rezultat:</span>
                <span className="awesome-result-value">{testimonial.result}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Summary Stats */}
        <div className="awesome-testimonials-summary">
          <div className="awesome-summary-stat">
            <span className="awesome-summary-value">4.9/5</span>
            <span className="awesome-summary-label">Srednia ocena</span>
          </div>
          <div className="awesome-summary-stat">
            <span className="awesome-summary-value">500+</span>
            <span className="awesome-summary-label">Pozytywnych opinii</span>
          </div>
          <div className="awesome-summary-stat">
            <span className="awesome-summary-value">95%</span>
            <span className="awesome-summary-label">Poleca znajomym</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCaseStudy;
